export const WEBCAM_QUALITY_IDS = ['sd', 'hd', 'fhd'] as const

export type WebcamQualityId = typeof WEBCAM_QUALITY_IDS[number]

export const DEFAULT_WEBCAM_QUALITY: WebcamQualityId = 'fhd'

export const WEBCAM_QUALITY_PRESETS: Record<WebcamQualityId, { width: number, height: number }> = {
  sd: { width: 640, height: 480 },
  hd: { width: 1280, height: 720 },
  fhd: { width: 1920, height: 1080 },
}

export const WEBCAM_QUALITY_I18N_KEYS: Record<WebcamQualityId, string> = {
  sd: 'soundAndVideo.webcamQualitySd',
  hd: 'soundAndVideo.webcamQualityHd',
  fhd: 'soundAndVideo.webcamQualityFhd',
}

const webcamFrameRate = { ideal: 24, max: 24 }

export const isWebcamQualityId = (value: unknown): value is WebcamQualityId => {
  return typeof value === 'string' && (WEBCAM_QUALITY_IDS as readonly string[]).includes(value)
}

export const parseWebcamQualityId = (value: unknown): WebcamQualityId => {
  return isWebcamQualityId(value) ? value : DEFAULT_WEBCAM_QUALITY
}

export const getWebcamVideoConstraints = (
  quality: WebcamQualityId,
  deviceId?: string,
  hasDevice = false,
): MediaTrackConstraints => {
  const preset = WEBCAM_QUALITY_PRESETS[parseWebcamQualityId(quality)]
  const constraints: MediaTrackConstraints = {
    width: { ideal: preset.width, max: preset.width },
    height: { ideal: preset.height, max: preset.height },
    frameRate: webcamFrameRate,
  }

  if (deviceId && hasDevice) {
    constraints.deviceId = { exact: deviceId }
  }

  return constraints
}
